import { Button } from "react-bootstrap";
import {
  FieldValues,
  FormProvider,
  useForm,
  UseFormReturn,
} from "react-hook-form";
import { toast } from "react-toastify";

import {
  getServiceOrderTypeValuesByType,
  ServiceOrderType,
} from "@/_constants/serviceOrder.ts";

import { ITenant } from "../reducers";
import ServiceOrderingInformationsForm from "./form/ServiceOrderingInformationsForm";
import ServiceOrderingPropertyForm from "./form/ServiceOrderingPropertyForm";
import ServiceOrderingTenantForm from "./form/ServiceOrderingTenantForm";
import {
  TServiceInventoryStoreState,
  useServiceInventoryStore,
} from "../store/ServiceInventoryStore";
import ServiceOrderingAppointmentForm from "./form/ServiceOrderingAppointmentForm";
import ServiceOrderingKeysForm from "./form/ServiceOrderingKeysForm";
import ServiceOrderingOperatorForm from "./form/ServiceOrderingOperatorForm.tsx";

const IncomingInventoryForm = () => {
  const {
    dwelling,
    inventory,
    incomingTenants,
    key,
    tenantLeaseStartDate,
    isManagedByMainGroup,
    isConfirmed,
    setData,
    operator,
    manager,
    businessServiceType,
  } = useServiceInventoryStore((state) => state);
  const methods: UseFormReturn = useForm<FieldValues>({
    defaultValues: {
      dwelling,
      operator,
      isManagedByMainGroup,
      manager,
      isConfirmed,
      incomingTenants: incomingTenants ||
        dwelling?.incomingTenants?.map((el: ITenant) => {
          return {
            idDwelling: el.id,
            lastname: el.person.lastname,
            firstname: el.person.firstname,
            email: el.person.email,
            phone: el.person.phone,
            rentalStartDate: el.rentalStartDate,
          };
        }) || [{}],
      inventory: inventory || { type: ServiceOrderType.INCOMING_INVENTORY },
      key,
      tenantLeaseStartDate,
    },
  });
  const onSubmit = (data: TServiceInventoryStoreState) => {
    const result = {
      ...data,
      businessServiceType,
    };
    setData(result);
    toast.success(
      `${
        getServiceOrderTypeValuesByType(ServiceOrderType.INCOMING_INVENTORY)
          ?.label
      } ajouté au panier`
    );
  };
  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className="d-flex flex-column gap-3"
      >
        <ServiceOrderingPropertyForm
          name="dwelling"
          rules={{ required: "Veuillez renseigner un bien" }}
        />
        <div className="border-bottom" />
        <ServiceOrderingTenantForm type="incoming" />
        <div className="border-bottom" />
        <ServiceOrderingAppointmentForm name="inventory" />
        <div className="border-bottom" />
        <ServiceOrderingOperatorForm
          onExpertByDefault={false}
          specificLabel="etat des lieux d'entrée"
          type={ServiceOrderType.INCOMING_INVENTORY}
        />
        <div className="border-bottom" />
        <ServiceOrderingKeysForm name="key" />
        <div className="border-bottom" />
        <ServiceOrderingInformationsForm name="inventory.comment" />
        <div className="d-flex justify-content-end">
          <Button variant={"primary"} type={"submit"}>
            {inventory ? "Modifier" : "Ajouter"}
          </Button>
        </div>
      </form>
    </FormProvider>
  );
};

export default IncomingInventoryForm;
